export default __webpack_public_path__ + "static/media/location-pin.fdd0bf97.svg";